import { useSiteContent } from '@/hooks/useSiteContent';
import ContentState from '@/components/feature/ContentState';

interface ChatCommitmentData {
  title: string;
  highlight: string;
  scenario: string;
  result: string;
  messages: { time: string; sender: 'guest' | 'ops'; text: string }[];
}

export default function CommitmentChat() {
  const { data, loading, error, refresh } = useSiteContent<ChatCommitmentData>(
    'why_us_chat_commitment',
  );

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="w-full bg-primary-500 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-3">
            {data.title}{' '}
            <span className="text-white/90">{data.highlight}</span>
          </h2>
          <p className="text-center text-white/80 text-sm md:text-base mb-10">
            {data.scenario}
          </p>

          {/* Chat Bubbles */}
          <div className="bg-white rounded-2xl p-5 md:p-8 space-y-4 max-w-2xl mx-auto shadow-lg">
            {data.messages.map((msg, idx) => (
              <div
                key={idx}
                className={`flex ${msg.sender === 'ops' ? 'justify-start' : 'justify-end'}`}
              >
                <div
                  className={`max-w-[85%] rounded-2xl px-4 py-3 ${
                    msg.sender === 'ops'
                      ? 'bg-background-100 text-foreground-800 rounded-tl-sm'
                      : 'bg-primary-500 text-white rounded-tr-sm'
                  }`}
                >
                  <p className="text-sm leading-relaxed">{msg.text}</p>
                  <p
                    className={`text-[10px] mt-1 ${
                      msg.sender === 'ops' ? 'text-foreground-500' : 'text-white/70'
                    }`}
                  >
                    {msg.time}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-time-line" />
              {data.result}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}